const country = localStorage.getItem('country');

// dont change position of values, if done check usage
export const InventoryPublish = {
  PUBLISH: 'Publish',
  UNPUBLISH: 'Unpublish',
  PUBLISH_FAILED: 'Publish Failed',
};

export const SOLD_STATUS = {
  yes: {
    label: 'Yes',
    value: true,
  },
  no: {
    label: 'No',
    value: false,
  },
};

export const InventoryStatus = {
  BOUGHT: 'Bought',
  STOCK_IN: 'Stock In',
  STOCK_OUT: 'Stock Out',
  STOCK_TRANSFER: 'Stock Transfer',
};

export const InventoryLabels = (function () {
  switch (country) {
    case 'AU':
      return {
        'Source Pick-up': 'Source Pick-up',
        'At Source': 'At Source',
        Parked: 'Parked',
        'Source Pick-up (C2B)': 'Source Pick-up (C2B)',
        'Source Pick-up (Trade-in)': 'Source Pick-up (Trade-in)',
        'At Source (C2B)': 'At Source (C2B)',
        'At Source (Trade-in)': 'At Source (Trade-in)',
        'Sourcing Cancellation': 'Sourcing Cancellation',
        'Sourcing return': 'Sourcing return',
        Disposal: 'Disposal',
        STOCK_OUT: 'Stock Out',
      };
    default:
      return {
        BOUGHT: 'Bought',
        STOCK_IN: 'Stock In',
        STOCK_OUT: 'Stock Out',
        STOCK_TRANSFER: 'Stock Transfer',
      };
  }
})();

export const INVENTORY_SOURCE = (function () {
  switch (country) {
    case 'IN': {
      return {
        GS: 'GS',
        DEALER: 'Dealer',
      };
    }
    case 'AU': {
      return {
        B2C: 'B2C',
        C2B: 'C2B',
      };
    }
    default:
      return {};
  }
})();

export const InventoryStatusKeys = {
  BOUGHT: 'BOUGHT',
  STOCK_IN: 'STOCK_IN',
  STOCK_OUT: 'STOCK_OUT',
  STOCK_TRANSFER: 'STOCK_TRANSFER',
};

export const DriverStatus = {
  pending: 'Pending',
  confirmed: 'Confirmend',
  driver_assigned: 'Driver Assigned',
  driver_on_way: 'Driver On Way',
  running: 'Running',
  done: 'Done',
  cancelled: 'Cancelled',
  rejected: 'Rejected',
  disputed: 'Disputed',
};

export const RequestStatus = {
  PENDING: 'Pending',
  REQUESTED: 'Requested',
  IN_TRANSIT: 'In Transit',
  DONE: 'Done',
  ACCEPTED: 'Accepted',
  DENIED: 'Denied',
  DRIVER_ASSIGNED: 'Driver Assigned',
  DISPUTED: 'Disputed',
  PARTIAL: 'Partial',
  DRIVER_ON_WAY: 'Driver On Way',
  NOT_RAISED: 'Not Raised',
};

export const LogisticManagementLabels = (function () {
  switch (country) {
    case 'AE':
    case 'KSA':
      return {
        PENDING: 'Pending',
        DENIED: 'Denied',
        IN_TRANSIT: 'In Transit',
        DRIVER_ASSIGNED: 'Driver Assigned',
        ACCEPTED: 'Accepted',
      };
    case 'AU':
      return {
        PENDING: 'Pending',
        DRIVER_ASSIGNED: 'Driver Assigned',
        IN_TRANSIT: 'In Transit',
      };
    default:
      return {
        PENDING: 'Pending',
        DENIED: 'Denied',
      };
  }
})();

export const DocumentLabels = {
  IN_TRANSIT: 'In Transit',
  STOCK_IN: 'Stocked In',
  DELIVERED_TO_CUSTOMER: 'Delivered',
  DELIVERED_TO_SALES: 'Delivered',
  LOST: 'Lost',
  PENDING: 'Pending',
};

// TODO: Create a separate config for location types to segregate the logic and keep all the config clean
export const LocationType = {
  C2B_YARD: 'C2B Yard',
  SERVICE_CENTER: 'Service Center',
  CAR_STUDIO: 'Studio',
  FULFILLMENT_CENTER: 'Fulfillment Center',
  DEALER: 'Dealer',
  DLT: 'DLT',
  CARS24_INSPECTION_AREA: 'CARS24 Inspection Area',
};

export const LocationTypesForReturn = {
  C2B_YARD: 'C2B Yard',
  SERVICE_CENTER: 'Service Center',
  CAR_STUDIO: 'Studio',
  FULFILLMENT_CENTER: 'Fulfillment Center',
  DEALER: 'Dealer',
};

// TODO: Use same config for LocationTypeForMaster and pickupLocationType
export const LocationTypeForMaster = {
  TOUCH_POINT: 'Loading point',
  DEALER: 'Dealer',
  C2B_YARD: 'C2B Yard',
  SERVICE_CENTER: 'Service Center',
  CAR_STUDIO: 'Studio',
  FULFILLMENT_CENTER: 'Fulfillment Center',
  CORPORATE_OFFICE: 'Corporate Office',
  PARENT_HUB: 'Parent Hub',
  PI_PDI_YARD: 'PI/PDI Yard',
  DEALER_PNS: 'Dealer PNS',
  OD_SERVICE_CENTER: 'OD Service Center',
  WARRANTY_SERVICE_CENTER: 'Warranty Service Center',
};

// TODO: Use same config for LocationTypeForMaster and pickupLocationType
export const pickupLocationType = {
  C2B_YARD: 'C2B Yard',
  SERVICE_CENTER: 'Service Center',
  CAR_STUDIO: 'Studio',
  FULFILLMENT_CENTER: 'Fulfillment Center',
  TOUCH_POINT: 'Loading Point',
  DEALER: 'Dealer',
};

export const LocationTypesKey = {
  FULFILLMENT_CENTER: 'FULFILLMENT_CENTER',
  CAR_STUDIO: 'CAR_STUDIO',
  SERVICE_CENTER: 'SERVICE_CENTER',
  C2B_YARD: 'C2B_YARD',
  DEALER: 'DEALER',
};

export const LocationSubType = {
  RTA: 'RTA',
  DLT: 'DLT',
  B2B_VENDOR: 'B2B_VENDOR',
  EXTERNAL_VENDOR: 'EXTERNAL_VENDOR',
  CARS24_INSPECTION_AREA: 'CARS24_INSPECTION_AREA',
};

export const RequestTypes = [
  {
    requestType: 'Internal',
    key: 'INTERNAL',
  },
  {
    requestType: 'External',
    key: 'EXTERNAL',
  },
];

export const DriverType = {
  DriveU: 'DriveU',
  c24: 'In House',
  C2B: 'C2B',
  Offline: 'Offline',
  Locus: 'Locus',
};

export const LogisticProviderTypes = {
  DRIVEU: 'DriveU',
  OFFLINE: 'Offline',
  LOCUS: 'locus',
  C2B: 'C2B',
  ZOFEUR: 'Zofeur',
};

export const AlertType = {
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info',
  NONE: 'none',
};

export const placeType = {
  location: 'LOCATION',
};

export const uploadType = {
  make: 'make',
  model: 'model',
  variant: 'variant',
  inventory: 'inventory',
  location: 'location',
  post_purchase: 'Post Purchase',
  post_refurb: 'Post Refurb',
  publish_unpublish: 'Publish/Unpublish',
  location_pincodes: 'Location Pincodes',
  spec_features: 'Spec Features',
  serviceable_pincodes: 'Serviceable Pincodes',
  service_history: 'Service History',
  warranty: 'Warranty',
  transportation_charges: 'Transportation Charges',
};

export const AdditionalInventoryState = ['TRIP_END', 'TRIP_START'];

export const file_type = '.csv';

export const ErrorMessage = {
  unknown: 'Something went wrong. Please try again.',
  status400: 'Invalid data. Please check and try again.',
};

// TODO: Move country and vehicle related config in a separate config file
export const Country = {
  IN: 'IN',
  AE: 'AE',
  AU: 'AU',
  TH: 'TH',
  KSA: 'KSA',
  ID: 'ID',
};

export const Vehicle = {
  BIKE: 'BIKE',
  CAR: 'CAR',
};

const countryCheck = localStorage.getItem('country');
export const BulkUploadType = {
  inventory: 'generic',
  post_purchase: '-post-purchase',
  post_refurb: countryCheck === '-post-refurb',
  post_refurb_in: '-post-refurb',
};

export const BulTypeInspection = 'inspection-upload-';
export const BulkTypeInventory = 'inventory-upload-';

export const LOCATION_POINT_DROPDOWN_LIST = [
  { key: 'homePickUp', value: 'Home pick-up' },
  { key: 'dropAtHub', value: 'Drop at hub' },
];

export const RETURN_FLOW = {
  CUSTOMER_RETURN_FLOW: 'CUSTOMER_RETURN_FLOW',
  INTERNAL_RETURN_FLOW: 'INTERNAL_RETURN_FLOW',
  CUSTOMER_REPAIR_FLOW: 'CUSTOMER_REPAIR_FLOW',
};

export const DATE_FORMAT = 'yyyy-MM-dd';

export const CITIES_GROUP = {
  NCR: [
    'CC_134',
    'CC_5',
    'CC_8791',
    'CC_6',
    'CC_132',
    'CC_62',
    'CC_1',
    'CC_2',
    'CC_3',
    'CC_86',
    'CC_134',
  ],
  CH: ['CC_769', 'CC_650', 'CC_79'],
  GJ: ['CC_1692', 'CC_1605', 'CC_1606'],
  MH: ['CC_2378', 'CC_2598', 'CC_2713'],
};

export const STOCK_OUT_FLOW = {
  CUSTOMER_DELIVERY_FLOW: 'CUSTOMER_DELIVERY_FLOW',
  DIRECT_STOCK_OUT_FLOW: 'DIRECT_STOCK_OUT_FLOW',
  C2B_DELIVERY_FLOW: 'C2B_DELIVERY_FLOW',
  C2B_STOCK_OUT_FLOW: 'C2B_STOCK_OUT_FLOW',
  DEALER_DIRECT_STOCK_OUT_FLOW: 'DEALER_DIRECT_STOCK_OUT_FLOW',
  DEALER_DELIVERY_FLOW: 'DEALER_DELIVERY_FLOW',
  TEST_DRIVE_FLOW: 'TEST_DRIVE_FLOW',
  SELF_TEST_DRIVE_FLOW: 'SELF_TEST_DRIVE_FLOW',
  RTA_FLOW: 'RTA_FLOW',
  DELIVERY_THROUGH_EXPORT_PASSING: 'DELIVERY_THROUGH_EXPORT_PASSING',
  OUT_FOR_RTA_AND_STOCK_IN: 'OUT_FOR_RTA_AND_STOCK_IN',
  OUT_FOR_DLT_AND_RETURN: 'OUT_FOR_DLT_AND_RETURN',
  B2B_VENDOR_DELIVERY_FLOW: 'B2B_VENDOR_DELIVERY_FLOW',
  RTA_FLOW_SINGLE_MOVEMENT: 'RTA_FLOW_SINGLE_MOVEMENT',
};

export const STOCK_OUT_FLOW_WITH_SUB_REASON = {
  SERVICE_CONTRACTS: 'Service contracts',
};

export const TIME_SLOT_TYPE = {
  INTERNAL_PICKUPS: 'INTERNAL_PICKUPS',
  OUT_FOR_DELIVERY_TD: 'OUT_FOR_DELIVERY_TD',
  SELF_TEST_DRIVE: 'SELF_TEST_DRIVE',
};

export const ZONE_TYPES = {
  PRIMARY: 'PRIMARY',
  COLLECTION: 'COLLECTION',
};

export const COLLECTION_TYPES = {
  city: 'CITY',
  state: 'STATE',
  zone: 'ZONE',
};

export const STOCK_IN_OPTIONS = {
  registrationNumber: {
    label: 'Registration Number',
    value: 'registrationNumber',
  },
  chassisNumber: {
    label: 'Chassis Number',
    value: 'chassisNumber',
  },
};
export const PANEL_MAIN_MENUS = {
  INVENTORY: 'INVENTORY',
  LOGISTIC: 'LOGISTIC',
  SCHEDULED_TASKS: 'SCHEDULED_TASKS',
  BIG_DEALER_NETWORK: 'BIG_DEALER_NETWORK',
  DRIVER_MANAGEMENT: 'DRIVER_MANAGEMENT',
  USER_MANAGEMENT: 'USER_MANAGEMENT',
  USER_MANAGEMENT_V2: 'USER_MANAGEMENT_V2',
  USER_PREFERENCES: 'USER_PREFERENCES',
  LOCATION: 'LOCATION',
  MASTER_DATA: 'MASTER_DATA',
  BULK_UPLOAD: 'BULK_UPLOAD',
  CONFIGS: 'CONFIGS',
  DOCUMENT_PENDENCY: 'DOCUMENT_PENDENCY',
  KEY_MANAGEMENT: 'KEY_MANAGEMENT',
  ENBD_RSTL: 'ENBD_RSTL',
  FASTAG: 'FASTAG',
  CAR_CLEANING_QA: 'CAR_CLEANING_QA',
  CAR_CLEANING_HISTORY: 'CAR_CLEANING_HISTORY',
  TRAINING_TUTORIALS: 'TRAINING_TUTORIALS',
  COUPON_REQUESTS: 'COUPON_REQUESTS',
  COUPON_CONFIG_MANAGEMENT: 'COUPON_CONFIG_MANAGEMENT',
};

export const PANEL_MAIN_MENU_ITEMS = [
  {
    key: PANEL_MAIN_MENUS.INVENTORY,
    title: 'Inventory',
    path: '/inventory',
    icon: 'k-icon k-i-list-ordered k-i-list-numbered',
  },
  {
    key: PANEL_MAIN_MENUS.LOGISTIC,
    title: 'Logistic',
    path: '/logistic',
    icon: 'k-icon k-i-marker-pin-target',
  },
  {
    key: PANEL_MAIN_MENUS.SCHEDULED_TASKS,
    title:
      country === Country.TH ? 'SF Scheduled Logistics' : 'Scheduled Logistics',
    path: '/scheduled-tasks',
    icon: 'k-icon k-i-clock',
  },
  {
    key: PANEL_MAIN_MENUS.BIG_DEALER_NETWORK,
    title: 'Big Dealer Network',
    path: '/big-dealer',
    icon: 'k-icon k-i-checkbox-checked',
  },
  {
    key: PANEL_MAIN_MENUS.DRIVER_MANAGEMENT,
    title: 'Driver Management',
    path: '/driver',
    icon: 'k-icon k-i-user',
  },
  {
    key: PANEL_MAIN_MENUS.USER_MANAGEMENT,
    title: 'User Management',
    path: '/user-management',
    icon: 'k-icon k-i-myspace',
  },
  {
    key: PANEL_MAIN_MENUS.USER_MANAGEMENT_V2,
    title: 'User Management',
    path: '/ums',
    icon: 'k-icon k-i-myspace',
  },
  {
    key: PANEL_MAIN_MENUS.USER_PREFERENCES,
    title: 'User Preferences',
    path: '/user-preferences',
    icon: 'k-icon k-i-gear',
  },
  {
    key: PANEL_MAIN_MENUS.LOCATION,
    title: 'Location',
    path: '/location',
    icon: 'k-icon k-i-home',
  },
  {
    key: PANEL_MAIN_MENUS.MASTER_DATA,
    title: 'Masterdata',
    path: '/masterdata',
    icon: 'k-icon k-i-data',
  },
  {
    key: PANEL_MAIN_MENUS.BULK_UPLOAD,
    title: 'Bulk Operations',
    path: '/bulk-upload-v2',
    icon: 'k-icon k-i-upload',
  },
  {
    key: PANEL_MAIN_MENUS.CONFIGS,
    title: 'Configurations',
    path: '/configs',
    icon: 'k-icon k-i-settings',
  },
  {
    key: PANEL_MAIN_MENUS.DOCUMENT_PENDENCY,
    title: 'Documents',
    path: '/document-pendency',
    icon: 'k-icon k-i-folder-open',
  },
  {
    key: PANEL_MAIN_MENUS.KEY_MANAGEMENT,
    title: 'Key Management',
    path: '/key-management',
    icon: 'k-icon k-i-lock',
  },
  {
    key: PANEL_MAIN_MENUS.ENBD_RSTL,
    title: 'ENBD RSTL',
    path: '/enbd-rstl',
    icon: 'k-icon k-i-data',
  },
  {
    key: PANEL_MAIN_MENUS.FASTAG,
    title: 'FASTag',
    path: '/fastag',
    icon: 'k-icon k-i-flash',
  },
  {
    key: PANEL_MAIN_MENUS.CAR_CLEANING_QA,
    title: 'Car Cleaning QA',
    path: '/car-cleaning-qa',
    icon: 'k-icon k-i-apply-format',
  },
  {
    key: PANEL_MAIN_MENUS.CAR_CLEANING_HISTORY,
    title: 'Car Cleaning History',
    path: '/car-cleaning-history',
    icon: 'k-icon k-i-apply-format',
  },
  {
    key: PANEL_MAIN_MENUS.TRAINING_TUTORIALS,
    title: 'Training Tutorials',
    path: '/training-tutorials',
    icon: 'k-icon k-i-apply-format',
  },
  {
    key: PANEL_MAIN_MENUS.COUPON_REQUESTS,
    title: 'Coupon Requests',
    path: '/coupon-requests',
    icon: 'k-icon k-i-data',
  },
  {
    key: PANEL_MAIN_MENUS.COUPON_CONFIG_MANAGEMENT,
    title: 'Coupon Config',
    path: '/coupon-config-management',
    icon: 'k-icon k-i-gear',
  },
];

export const LOCAL_STORAGE_KEYS = {
  INVENTORY_COLUMNS: 'inventory-grid-columns',
  LOGISTIC_COLUMNS: 'logistics-grid-columns',
  BIG_DEALER_NETWORK_COLUMNS: 'big-dealer-network-grid-columns',
  DRIVER_MANAGEMENT_COLUMNS: 'driver-management-grid-columns',
  LOCATION_COLUMNS: 'location-grid-columns',
  DOCUMENT_MANAGEMENT_COLUMNS: 'document-management-grid-columns',
  MASTERDATA_COLUMNS_CITY: 'masterdata-grid-columns-city',
  MASTERDATA_COLUMNS_STATE: 'masterdata-grid-columns-state',
  MASTERDATA_COLUMNS_ZONE: 'masterdata-grid-columns-zones',
  MASTERDATA_COLUMNS_INTERCITY: 'masterdata-grid-columns-intercity',
  MASTERDATA_COLUMNS_PINCODE: 'masterdata-grid-columns-pincode',
  BULK_UPLOAD_COLUMNS: 'bulk-upload-grid-columns',
  BULK_UPLOAD_COLUMNS_V2: 'bulk-upload-grid-columns-v2',
  COUPON_REQUESTS_COLUMNS: 'coupon-requests-grid-columns',
  COUPON_REQUESTS_APPROVER_COLUMNS: 'coupon-requests-approver-grid-columns',
  COUPON_REQUESTS_REQUESTER_COLUMNS: 'coupon-requests-requester-grid-columns',
  COUPON_CONFIG_AUDIT_LOGS_COLUMNS: 'coupon-config-audit-logs-grid-columns',
  KEY_MANAGEMENT_REQUESTS_COLUMN: 'key-request-grid-column',
  KEY_MANAGEMENT_OUTKEYS_COLUMN: 'key-out-request-grid-column',
  KEY_MANAGEMENT_AUDIT_TRAIL: 'key-audit-trail',
  USER_MANAGEMENT_COLUMNS: 'user-management-grid-columns',
  CONFIG_MANAGEMENT_COLUMNS: 'config-management-grid-columns',
  SCHEDULED_TASKS_COLUMNS: 'scheduled-tasks-grid-columns',
  USER_MANAGEMENT_V2_COLUMNS: 'ums-grid-columns',
  DND_LIST_COLUMNS: 'dnd-list-columns',
  USER_GROUPS: 'user-groups',
  FASTAG_FULFILMENT_COLUMNS: 'fastag-fulfilment-columns',
};

export const NUMBERS = {
  ZERO: 0,
  ONE: 1,
  TWO: 2,
  THREE: 3,
  FOUR: 4,
  FIVE: 5,
  SIX: 6,
  SEVEN: 7,
  EIGHT: 8,
  NINE: 9,
  TEN: 10,
};

export const ASSET_STATUS = {
  STOCK_IN: 'Stock In',
  IN_TRANSIT: 'In Transit',
  DELIVERED_TO_CUSTOMER: 'Delivered to Customer',
  DELIVERED_TO_SALES: 'Delivered to Sales',
  LOST: 'Lost',
  PENDING: 'Pending',
};

export const KEY_MANAGEMENT_ACTION = {
  CANCEL_REQUEST: 'CANCEL_REQUEST',
  MARK_RECEIVED: 'MARK_RECEIVED',
  READY_TO_BE_PICKED: 'READY_TO_BE_PICKED',
};

export const KEY_MANAGEMENT_ROLES = {
  UAE_KEY_MANAGER: 'UAE_KEY_MANAGER',
  UAE_KEY_REQUESTER: 'UAE_KEY_REQUESTER',
};

export const SLA_BREACHED_STATUS = [
  { label: 'Yes', value: 'true' },
  { label: 'No', value: 'false' },
];
export const INVENTORY_FIELDS = {
  'Listing Price': {
    title: 'Listing Price',
    fields: 'listingPrice,inventoryAttributes',
    contiguousKey: 'listingPrice',
    action: 'CREATE_INVENTORY,UPDATE_INVENTORY,PRICE_UPDATE',
    columns: [
      {
        title: 'Listing Price',
        cell: (e) => <td>{e.dataItem?.listingPrice}</td>,
      },
      {
        title: 'Reason',
        cell: (e) => (
          <td>{e.dataItem?.inventoryAttributes?.priceChangeReason || '-'}</td>
        ),
      },
    ],
  },
  'Inventory Status': {
    title: 'Inventory Status',
    fields: 'published,sold',
    contiguousKey: 'published_sold',
    action: null,
    columns: [
      {
        title: 'Inventory Status',
        cell: (e) => (
          <td>
            {e.dataItem?.sold
              ? 'Sold'
              : e.dataItem?.published
              ? 'Published'
              : 'Unpublished'}
          </td>
        ),
      },
    ],
  },
  'Target Price': {
    title: 'Target Price',
    fields: 'inventoryAttributes',
    contiguousKey: 'inventoryAttributes.targetPrice',
    action: 'CREATE_INVENTORY,UPDATE_INVENTORY,PRICE_UPDATE',
    columns: [
      {
        title: 'Target Price',
        cell: (e) => <td>{e.dataItem?.inventoryAttributes?.targetPrice}</td>,
      },
    ],
  },
  'Inventory Stage': {
    title: 'Inventory Stage',
    fields: 'inventoryAttributes',
    contiguousKey: 'inventoryAttributes.inventoryStage',
    ...(countryCheck === Country.AE
      ? {
          contiguousKey:
            'inventoryAttributes.inventoryStage_inventoryAttributes.inventorySubStage',
        }
      : {}),
    action: 'CREATE_INVENTORY,UPDATE_INVENTORY,UPDATE_INVENTORY_STAGE',
    columns: [
      {
        title: 'Inventory Stage',
        cell: ({ dataItem }) => {
          let { inventoryStage, inventorySubStage } =
            dataItem?.inventoryAttributes || {};
          let label = inventoryStage;
          if (inventorySubStage) {
            label += ` - ${inventorySubStage}`;
          }
          return <td>{label}</td>;
        },
      },
    ],
  },
  'Inventory Type': {
    title: 'Inventory Type',
    fields: 'inventoryAttributes',
    contiguousKey: 'inventoryAttributes.inventoryType',
    action: 'CREATE_INVENTORY,UPDATE_INVENTORY,UPDATE_INVENTORY_TYPE',
    columns: [
      {
        title: 'Inventory Type',
        cell: (e) => <td>{e.dataItem?.inventoryAttributes?.inventoryType}</td>,
      },
    ],
  },
  'Avg Market Price': {
    title: 'Avg Market Price',
    fields: 'inventoryAttributes,updatedAt,updatedBy',
    contiguousKey: 'inventoryAttributes.avgMarketPrice',
    action: 'PRICE_UPDATE,UPDATE_INVENTORY',
    columns: [
      {
        title: 'Avg Market Price',
        cell: (e) => <td>{e.dataItem?.inventoryAttributes?.avgMarketPrice}</td>,
      },
    ],
  },
};

export const BIG_DEALER_ACTIONS = {
  APPROVE: 'PENDING_ACTION_APPROVE',
  MODIFY: 'PENDING_ACTION_MODIFY',
  REJECT: 'PENDING_ACTION_REJECT',
};

export const PENDING_ACTION_TYPE = {
  OFFER_PRICE_UPDATE: 'OFFER_PRICE_UPDATE',
  LISTING_PRICE_UPDATE: 'LISTING_PRICE_UPDATE',
  PUBLISH_STATUS_UPDATE: 'PUBLISH_STATUS_UPDATE',
};

export const PENDING_ACTION_SUBTYPE = {
  PRICE_REVISION: 'PRICE_REVISION',
  INITIAL_PRICE_UPDATE: 'INITIAL_PRICE_UPDATE',
  PUBLISH: 'PUBLISH',
  UNPUBLISH: 'UNPUBLISH',
  PERMANENT_DELISTING: 'PERMANENT_DELISTING',
};

export const ActionTypes = {
  'Offer Price': [PENDING_ACTION_TYPE.OFFER_PRICE_UPDATE, ''],
  'Price Revision': [
    PENDING_ACTION_TYPE.LISTING_PRICE_UPDATE,
    PENDING_ACTION_SUBTYPE.PRICE_REVISION,
  ],
  'Listing Price': [
    PENDING_ACTION_TYPE.LISTING_PRICE_UPDATE,
    PENDING_ACTION_SUBTYPE.INITIAL_PRICE_UPDATE,
  ],
  Delisting: [
    PENDING_ACTION_TYPE.PUBLISH_STATUS_UPDATE,
    `${PENDING_ACTION_SUBTYPE.UNPUBLISH},${PENDING_ACTION_SUBTYPE.PERMANENT_DELISTING}`,
  ],
  Relisting: [
    PENDING_ACTION_TYPE.PUBLISH_STATUS_UPDATE,
    PENDING_ACTION_SUBTYPE.PUBLISH,
  ],
};

export const HELLO_AR_STATUS = {
  1: 'New',
  2: 'Uploaded',
  3: 'Published',
  4: 'Unpublished',
};

export const BREAKPOINTS = {
  xs: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1400,
};

export const OKTA_USER_STATUS = {
  STAGED: 'STAGED',
  PROVISIONED: 'STAGED',
  ACTIVE: 'ACTIVE',
  RECOVERY: 'RECOVERY',
  'PASSWORD EXPIRED': 'PASSWORD EXPIRED',
  'LOCKED OUT': 'LOCKED OUT',
  SUSPENDED: 'SUSPENDED',
  DEPROVISIONED: 'DEPROVISIONED',
};

export const TIMEZONE = {
  IN: 'Asia/Kolkata',
  AE: 'Asia/Dubai',
  TH: 'Asia/Bangkok',
  ID: 'Asia/Jakarta',
  KSA: 'Asia/Riyadh',
  AU: 'Australia/Sydney',
};

export const LOGISTIC_PROVIDER_SUBTYPE = {
  OWN_TRUCK: 'OWN_TRUCK',
  '3PL_VENDOR': '3PL_VENDOR',
  CARCIERGE: 'CARCIERGE',
  VENDOR_ORGANIZED: 'VENDOR_ORGANIZED',
};

export const BULK_ACTION = {
  CREATE_PICKUP_REQUEST: 'Create Pickup Request',
  SET_LOGISTIC_VENDOR: 'Set Logistic Vendor',
  MOVE_OUT: 'Move Out',
  PARK: 'Park',
  EMAIL_LOGISTICS_VENDOR: 'Email Vendor',
};

export const MAX_BULK_ACTION_ALLOWED = 25;

export const MAX_COMMENT_LENGTH_IN_MOVEMENT_CREATION = 120;

export const DRIVER_SKILL = {
  'Home TD': 'HOME_TD',
  Hub: 'HUB',
};

export const paginationOptions = [
  {
    label: 10,
    value: 10,
  },
  {
    label: 30,
    value: 30,
  },
  {
    label: 50,
    value: 50,
  },
  {
    label: 100,
    value: 100,
  },
];

export const defaultGridPageSize = (function () {
  switch (country) {
    case Country.AU:
      return 30;
    default:
      return 10;
  }
})();

export const AssetConfig = (function () {
  if (country == 'AE') {
    return {
      key: 'Asset',
      columns: {
        documentType: true,
        documentLocation: true,
        destinationLocation: false,
        slot: true,
        remarks: true,
        updatedBy: true,
        updatedAt: true,
      },
      markReceived: {
        title: 'Change Location',
      },
      locationType: 'FULFILLMENT_CENTER,CAR_STUDIO,SERVICE_CENTER',
    };
  }
  if (country == 'IN') {
    return {
      key: 'Document',
      columns: {
        documentType: true,
        documentLocation: true,
        destinationLocation: true,
        slot: false,
        remarks: true,
        updatedBy: true,
        updatedAt: true,
      },
      markReceived: {
        title: 'Mark Received',
      },
      locationType: 'FULFILLMENT_CENTER,C2B_YARD,CORPORATE_OFFICE',
    };
  }
})();

export const ROSTER_TYPE = {
  CA_ALLOCATION: 'CA_ALLOCATION',
  C2B_INSPECTOR_ALLOCATION: 'C2B_INSPECTOR_ALLOCATION',
};

export const weekDays = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday',
];

export const daysCollection = [
  { id: 1, day: 'monday' },
  { id: 2, day: 'tuesday' },
  { id: 3, day: 'wednesday' },
  { id: 4, day: 'thursday' },
  { id: 5, day: 'friday' },
  { id: 6, day: 'saturday' },
  { id: 7, day: 'sunday' },
];

export const USER_MANAGEMENT_USER_TYPE = {
  C24_EMPLOYEES: 'C24_EMPLOYEES',
  DSA: 'DSA',
  EXTERNAL: 'EXTERNAL',
};

export const USER_MANAGEMENT_SOURCE = {
  ALL: 'ALL',
  OKTA: 'OKTA',
  DESCOPE: 'DESCOPE',
};

export const MRL_DISABLE_INCOMING_LOGISTICS_REASON = {
  MRL_CLOSED: 'MRL Closed',
  CAPACITY_FULL: 'Capacity Full',
};

export const INVENTORY_TYPE = [
  { reason: 'TRADE', label: 'Trade' },
  { reason: 'RETAIL', label: 'Retail' },
  { reason: 'PENDING_TRADE', label: 'Pending Trade' },
  { reason: 'COMPANY_ASSET', label: 'Company Asset' },
  { reason: 'PENDING_COMPANY_ASSET', label: 'Pending Company Asset' },
  { reason: 'RETAIL_ON_HOLD', label: 'Retail On Hold' },
];

export const MRL_ZONE = {
  denting: 'Denting',
  prepping: 'Prepping',
  masking: 'Masking',
  painting: 'Painting',
  drying: 'Drying',
  fitting: 'Fitting',
  detailing: 'Detailing',
  bsqc: 'BSQC',
  'mech-service': 'Mech/Service',
  'ac-electrical-wheelshop': 'AC/Electrical/WheelShop',
};

export const spaceAllowedSearchFields = (function () {
  switch (country) {
    case Country.AU:
      return ['appointmentId', 'vin', 'stockId'];
    default:
      return [];
  }
})();

export const localityFieldInfoText =
  'This will be visible to the customer and thus enter the locality to denote the area which is known to them. For eg: GIP Mall, Sector-18, Noida';
export const howToReachFieldInfoText =
  'These instructions will be sent to customers to help them reach our hub easily for a test drive. Make the directions easy to follow for them.';

export const ORDER_STATUS = {
  RESERVED: 'RESERVED',
  BOOKED: 'BOOKED',
  DELIVERED: 'DELIVERED',
};

export const DRIVER_TYPE = {
  YARD_DRIVER: 'Yard Driver',
  VARIABLE_DRIVER: 'Variable Driver',
  FIXED_DRIVER: 'Fixed Driver',
};

export const ASSORTMENT_TYPE = {
  'BETA GO': 'Value Car',
  GO: 'GS',
  GAMMA: 'GAMMA',
};

export const KEY_HANDLER_TYPE = {
  DRIVER: 'DRIVER',
  CA: 'CA',
  CLEANER: 'CLEANER',
  MECHANIC: 'MECHANIC',
  OTHER: 'OTHER',
};

export const KEY_ACTION_TYPE = {
  KEY_DETAILS: 'KEY_DETAILS',
  SPARE_KEY_DETAILS: 'SPARE_KEY_DETAILS',
};

export const KEY_STATUS = {
  KEY_IN: 'KEY_IN',
  KEY_OUT: 'KEY_OUT',
};

export const KEY_STATUS_LABEL = {
  [KEY_STATUS.KEY_IN]: 'Key In',
  [KEY_STATUS.KEY_OUT]: 'Key Out',
};

export const KEY_MANAGEMENT_CTA_LABEL = {
  [KEY_STATUS.KEY_IN]: 'Key Handover',
  [KEY_STATUS.KEY_OUT]: 'Key In',
};

export const GOOGLE_API_DEBOUNCE = 1000;

const FILE_VERSION = process.env.REACT_APP_FILE_VERSION;

export const INVENTORY_SOURCE_TYPE = (function () {
  switch (country) {
    case 'AU': {
      return {
        RETAIL: 'RETAIL',
        WHOLESALE: 'WHOLESALE',
      };
    }
    default:
      return {};
  }
})();

export const STATE_CODE_LIST = [
  { code: 'AP', name: 'Andhra Pradesh' },
  { code: 'AR', name: 'Arunachal Pradesh' },
  { code: 'AS', name: 'Assam' },
  { code: 'BR', name: 'Bihar' },
  { code: 'CG', name: 'Chhattisgarh' },
  { code: 'CH', name: 'Chandigarh' },
  { code: 'DD', name: 'Daman and Diu' },
  { code: 'DL', name: 'Delhi (National Capital Territory)' },
  { code: 'DN', name: 'Dadra and Nagar Haveli' },
  { code: 'GA', name: 'Goa' },
  { code: 'GJ', name: 'Gujarat' },
  { code: 'HP', name: 'Himachal Pradesh' },
  { code: 'HR', name: 'Haryana' },
  { code: 'JH', name: 'Jharkhand' },
  { code: 'JK', name: 'Jammu and Kashmir' },
  { code: 'KA', name: 'Karnataka' },
  { code: 'KL', name: 'Kerala' },
  { code: 'LD', name: 'Lakshadweep' },
  { code: 'MH', name: 'Maharashtra' },
  { code: 'ML', name: 'Meghalaya' },
  { code: 'MN', name: 'Manipur' },
  { code: 'MP', name: 'Madhya Pradesh' },
  { code: 'MZ', name: 'Mizoram' },
  { code: 'NL', name: 'Nagaland' },
  { code: 'OD', name: 'Odisha' },
  { code: 'PB', name: 'Punjab' },
  { code: 'PY', name: 'Puducherry' },
  { code: 'RJ', name: 'Rajasthan' },
  { code: 'SK', name: 'Sikkim' },
  { code: 'TN', name: 'Tamil Nadu' },
  { code: 'TR', name: 'Tripura' },
  { code: 'TS', name: 'Telangana' },
  { code: 'UK', name: 'Uttarakhand' },
  { code: 'UP', name: 'Uttar Pradesh' },
  { code: 'WB', name: 'West Bengal' },
];

export const ServiceCentreOriginLocations = {
  C2B_YARD: 'C2B_YARD',
  PI_PDI_YARD: 'PI/PDI Yard',
};
export const ServiceCentreDestinationLocations = {
  CAR_STUDIO: 'Studio',
};

export const WEEKLY_OFF_DAYS = [
  { code: 'MONDAY', name: 'Monday' },
  { code: 'TUESDAY', name: 'Tuesday' },
  { code: 'WEDNESDAY', name: 'Wednesday' },
  { code: 'THURSDAY', name: 'Thursday' },
  { code: 'FRIDAY', name: 'Friday' },
  { code: 'SATURDAY', name: 'Saturday' },
  { code: 'SUNDAY', name: 'Sunday' },
];

export const FLOW_TYPE = {
  PARK_AND_SELL: 'PARK_AND_SELL',
};

export const FlowTypeLabels = (flowType) => {
  switch (flowType) {
    case FLOW_TYPE.PARK_AND_SELL:
      return 'Park and Sell';
    default:
      return flowType;
  }
};
